import { graphql } from '@/generated/gql';

export const NEGOTIATION_DEMAND_LIST_QUERY = graphql(/* GraphQL */ `
  query TesseractNegotiationDemandList(
    $offset: Int
    $limit: Int
    $filter: TsrctQueryBuilderQuery
    $order: [TsrctDemandOrder!]
  ) {
    tesseract {
      demands(offset: $offset, limit: $limit, filter: $filter, order: $order) {
        nodes {
          capabilityIds
          casesNegotiatedCount
          casesOpenCount
          casesTotalCount
          commodityGroupIds
          createdAt
          currency
          description
          earlyDeliveryAt
          id
          issuesOpenCount
          lateDeliveryAt
          links {
            name
            url
          }
          organizationId
          preferredSupplierIds
          priority
          processingMode
          purchaseRequisitionId
          referenceId
          requestedAt
          requestedBy
          responsibleIds
          sequenceNumber
          status
          processStatus
          processSteps {
            status
            variant
          }
          totalValue
          updatedAt
          sourceSystemId
        }
        totalCount
      }
    }
  }
`);
